var TIME_SYSTEM_TEXT;
(function (TIME_SYSTEM_TEXT) {
    TIME_SYSTEM_TEXT["PM"] = "PM";
    TIME_SYSTEM_TEXT["AM"] = "AM";
})(TIME_SYSTEM_TEXT || (TIME_SYSTEM_TEXT = {}));
var K_ENTER = 'Enter';
var K_SPACE = ' ';
export { K_ENTER, K_SPACE, TIME_SYSTEM_TEXT };
